module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Podgląd")]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.data.artists), function(artist) {
    return _c('li', {
      staticClass: "item"
    }, [_vm._v("\n            " + _vm._s(artist.name) + "\n        ")])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45ded292"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/ArtistsListWidget/ArtistsPreview.vue
// module id = 746
// module chunks = 0